import styled from 'styled-components';

const Recipients = styled.div``;

const RecipientsHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const RecipientHeaderLeft = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const RecipientHeaderTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 0.4rem;
  margin-bottom: 24px;
`;

const RecipientHeaderStrong = styled.strong`
  font-size: 20px;
`;

const RecipientHeaderText = styled.div`
  align-items: center;
  display: flex;
  gap: 0.4rem;
  justify-content: space-between;
`;

const RecipientsHeaderDivider = styled.div`
  background-color: var(--color-accent-secondary-weaker);
  height: 16px;
  margin: 0 1.6rem;
  width: 1px;
`;

const RecipientHeaderRight = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
`;

const RecipientName = styled.p`
  max-width: 150px;
  overflow: overlay;
`;

export {
  RecipientHeaderLeft,
  RecipientHeaderRight,
  RecipientHeaderStrong,
  RecipientHeaderText,
  RecipientHeaderTitle,
  RecipientName,
  Recipients,
  RecipientsHeader,
  RecipientsHeaderDivider
};
